import { render } from "./ExpandableFormGroup.vue?vue&type=template&id=3c259a34"
import script from "./ExpandableFormGroup.vue?vue&type=script&lang=js"
export * from "./ExpandableFormGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__